import React, { createContext, useState } from 'react';
import { fetchUserAPI, updateUserAPI } from '../apis/apiBaltee.js';

/*Change isAuthenticated to false by default when a user/login will be set*/
export const AuthContext = createContext({
  token: '',
  idUser: '',
  refreshToken: '',
  isAuthenticated: false,
  connected: false,
  currentUser: {},
  login: (token, idUser, refreshToken) => {},
  logout: () => {},
  initUser: (authToken_, authIdUser_) => {},
  updateUser: (authToken_, authIdUser_, data) => {},
});

function AuthContextProvider({ children }) {
  const [authToken, setAuthToken] = useState(localStorage.getItem('idToken') || '');
  const [authRefreshToken, setAuthRefreshToken] = useState(localStorage.getItem('idRefreshToken') || '');
  const [authIdUser, setAuthIdUser] = useState(localStorage.getItem('idUser') || '');
  const [currentUser, setCurrentUser] = useState(null);
  const [connected, setConnected] = useState(!!localStorage.getItem('idToken'));

  function login(token, idUser, refreshToken) {
    setConnected(true);

    setAuthIdUser(idUser);
    setAuthToken(token);
    setAuthRefreshToken(refreshToken);
    localStorage.setItem('idToken', token);
    localStorage.setItem('idRefreshToken', refreshToken);
    localStorage.setItem('idUser', idUser);
  }

  function logout() {
    setConnected(false);

    setAuthToken('');
    setAuthIdUser('');
    setAuthRefreshToken('');
    setCurrentUser(null);
    localStorage.removeItem('idToken');
    localStorage.removeItem('idRefreshToken');
    localStorage.removeItem('idUser');
    
  }

  async function initUser(authToken_, authIdUser_) {
    console.log('init user')
    try {
      const user = await fetchUserAPI(authToken_, authIdUser_);
      setCurrentUser(user);
      return true;
    } catch (error) {
      console.error("Erreur lors de l'initialisation de l'utilisateur :", error);
      return false;
    }
  }

  async function updateUser(authToken, authIdUser, data) {
    try {
      const user = await updateUserAPI(authToken, authIdUser, data);
      setCurrentUser(user);
      return true;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'utilisateur :", error);
      return false;
    }
  }

  const value = {
    token: authToken,
    refreshToken: authRefreshToken,
    idUser: authIdUser,
    isAuthenticated: !!authToken,
    currentUser: currentUser,
    connected: connected,
    login: login,
    logout: logout,
    initUser: initUser,
    updateUser: updateUser,
    setConnected: setConnected,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthContextProvider;
